import clsx from "clsx";

import { type Cell, flexRender } from "@tanstack/react-table";

interface Props<T> {
  cell: Cell<T, unknown>;
  className?: string;
}

export const BodyCell = <T,>({ cell, className }: Props<T>) => {
  const isFirst = cell.column.getIsFirstColumn();
  const isLast = cell.column.getIsLastColumn();
  const isPinned = cell.column.getIsPinned();
  const isPinnedLast = cell.column.getIsLastColumn("left");
  const startPosition = cell.column.getStart("left");

  return (
    <td
      className={clsx("p-0 group", className, {
        "is-first-column": isFirst,
        "is-last-column": isLast,
        "is-pinned sticky z-1": isPinned,
        "is-pinned-last": isPinnedLast,
      })}
      style={{
        width: cell.column.getSize(),
        left: isPinned ? startPosition : undefined,
      }}
    >
      {flexRender(cell.column.columnDef.cell, cell.getContext())}
    </td>
  );
};
